<template>
<div>
  <el-form ref="queryForm" :model="queryForm" label-width="260px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="启用配置" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="AccessKeyId" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入AccessKeyId"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="AccessKeySecret" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入AccessKeySecret"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="签名" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入签名"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="签名" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入签名"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="验证码模版编号" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入编号"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="审核账号通知" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="审核通知模版" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入审核通知模版"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <div slot="header" class="clearfix">
    <span style="color: #409EFF">订单驳回通知</span>
    <hr color="#aaa" size="0.2"/>
  </div>
  <el-form ref="queryForm" :model="queryForm1" label-width="260px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="订单驳回通知" prop="webTitle">
          <el-radio-group v-model="queryForm.isneedReview" @change="tackReviewChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="订单驳回通知模版" prop="webTitle">
          <el-input  v-model="queryForm.webTitle" placeholder="请输入通知模版"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
export default {
  name: "SmsCustomComponent",
  mixins:[MixinCUD],
  data(){
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      tableData:[],
      queryForm:{
        isneedReview:0,
      },
      checkList: [],
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      checkList1: []
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
.demo-input-suffix {
  margin-bottom: 15px;
}
hr{
  border: 1px solid #aaaaaa;
}
</style>
